import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn-play",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "btn-play-icon" }, "▶", -1)),
    _createElementVNode("span", {
      class: "btn-play-label",
      innerHTML: _ctx.label || _ctx.jsonData.tryGame
    }, null, 8, _hoisted_1)
  ]))
}